import NextPageWithServices from "@insightfulscience/smart-react/hocs/NextPageWithServices";
import revalidateService from "@insightfulscience/contentful/services/revalidateService";
import zendeskService from "@insightfulscience/federated-search";
import { privateConfig, publicConfig } from "../config";
import gqlClient from "./gqlClient";
import pureGqlClient from "./gqlClient/pure";
import recoveryService from "./recoveryService";
import authService from "./authService";
import routingService from "./routingService";
import gqlEventsListener from "./GtmGqlEvents";
import subscriptionService from "./subscriptionService";
import trialService from "./trialService";
import { apiMock } from "./storageService/apiMock";
import contactService from "./contactService";
import { pagePaths } from "../domain/revalidate";
import { persistent } from "./persistentStorage";
import daClient from "./daClient";
import { notifySentry } from "../sentry";

export const serviceCore = {
	publicConfig: () => publicConfig,
	privateConfig: () => privateConfig,
	...persistent,
	recoveryService,
	gqlClient,
	pureGqlClient,
	authService,
	routingService,
	gqlEventsListener,
	subscriptionService,
	trialService,
	contactService,
	apiMock,
	pagePaths: () => pagePaths,
	revalidateService,
	zendeskService: ({
		publicConfig: { ZENDESK_URL, ZENDESK_EMAIL, SITE_DOMAIN, CTF_API_URL, CTF_ENV, CTF_SPACE },
		privateConfig: { CTF_CMA_TOKEN, ZENDESK_TOKEN },
	}) =>
		zendeskService({
			config: {
				brand: "Geneious",
				ZENDESK_URL,
				ZENDESK_TOKEN,
				ZENDESK_EMAIL,
				SITE_DOMAIN,
				CTF_API_URL,
				CTF_CMA_TOKEN,
				CTF_ENV,
				CTF_SPACE,
			},
		}),
	daClient,
	reportError: () => notifySentry,
};

export default NextPageWithServices(serviceCore);
